(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["laboosh-menu-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.getElementById('laboosh-menu');
    if (!drawer) return;
    const panel = drawer.querySelector('.laboosh-menu__panel');
    let lastFocus;
    let background = [];
    function setOpen(open) {
      if (open === drawer.classList.contains('laboosh-menu--open')) return;
      if (open) {
        lastFocus = document.activeElement;
        background = [];
        let branch = drawer;
        while (branch.parentElement && branch !== document.body) {
          [...branch.parentElement.children].filter(el => el !== branch && !['SCRIPT','STYLE','LINK'].includes(el.tagName)).forEach(el => background.push({el,inert:el.inert}));
          branch = branch.parentElement;
        }
        background.forEach(({el}) => { el.inert = true; });
      } else {
        background.forEach(({el,inert}) => { el.inert = inert; });
        background = [];
      }
      drawer.inert = !open;
      drawer.classList.toggle('laboosh-menu--open',open);
      drawer.setAttribute('aria-hidden',String(!open));
      document.documentElement.classList.toggle('laboosh-menu-open',open);
      document.body.classList.toggle('laboosh-menu-open',open);
      document.querySelectorAll('.laboosh-burger').forEach(btn => btn.setAttribute('aria-expanded',String(open)));
      if (open) {
        drawer.querySelector('.laboosh-menu__body').scrollTop = 0;
        drawer.querySelector('[data-laboosh-menu-close]').focus();
      } else {
        drawer.querySelectorAll('[data-laboosh-menu-toggle],[data-laboosh-menu-toggle-sub]').forEach(btn => { btn.setAttribute('aria-expanded','false'); document.getElementById(btn.getAttribute('aria-controls')).hidden = true; });
        drawer.querySelector('.laboosh-menu__localization').open = false;
        if (lastFocus && lastFocus.isConnected) lastFocus.focus();
      }
    }
    drawer.querySelectorAll('[data-laboosh-menu-close]').forEach(btn => btn.addEventListener('click',() => setOpen(false)));
    drawer.querySelectorAll('[data-laboosh-menu-toggle],[data-laboosh-menu-toggle-sub]').forEach(btn => btn.addEventListener('click',() => {
      const expanded = btn.getAttribute('aria-expanded') !== 'true';
      if (btn.hasAttribute('data-laboosh-menu-toggle')) {
        drawer.querySelectorAll('[data-laboosh-menu-toggle]').forEach(other => {
          if (other !== btn) { other.setAttribute('aria-expanded','false'); document.getElementById(other.getAttribute('aria-controls')).hidden = true; }
        });
      }
      btn.setAttribute('aria-expanded',String(expanded));
      document.getElementById(btn.getAttribute('aria-controls')).hidden = !expanded;
    }));
    drawer.addEventListener('keydown',event => {
      if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href],button,input:not([type="hidden"]),select,summary')].filter(el => !el.disabled && !el.closest('[hidden]') && (el.tagName === 'SUMMARY' || !el.closest('details:not([open])')) && el.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length-1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    drawer.querySelectorAll('a').forEach(link => link.addEventListener('click',() => setOpen(false)));
    function bindBurger() {
      const header = document.querySelector('header-component');
      if (!header) return false;
      let burger = header.querySelector('.laboosh-burger');
      if (!burger) {
        burger = document.createElement('button');
        burger.type = 'button';
        burger.className = 'laboosh-burger';
        burger.setAttribute('aria-label',drawer.getAttribute('aria-label'));
        burger.setAttribute('aria-controls','laboosh-menu');
        burger.setAttribute('aria-expanded','false');
        burger.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M3 5h18M3 12h18M3 19h18"/></svg>';
        header.appendChild(burger);
      }
      if (!burger.dataset.editorialBound) {
        burger.dataset.editorialBound = 'true';
        burger.addEventListener('click',event => { event.preventDefault(); setOpen(true); });
      }
      return true;
    }
    window.LabooshMenu = {open:() => setOpen(true),close:() => setOpen(false),toggle:() => setOpen(!drawer.classList.contains('laboosh-menu--open'))};
    if (!bindBurger()) {
      let retries = 0;
      const timer = setInterval(() => { if (bindBurger() || ++retries === 15) clearInterval(timer); },200);
    }
    document.addEventListener('shopify:section:load',bindBurger);
  })();
  } catch(e) { console.error(e); }
})();

})();
